var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"mx-2 mt-n2 mb-2"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('content-section',_vm._b({attrs:{"show-title":false},scopedSlots:_vm._u([{key:"extended",fn:function(){return [_vm._t("extended")]},proxy:true}],null,true)},'content-section',_vm.content,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }